import React, { useEffect } from 'react';
import Banner01 from '../components/banner/Banner01';
import Banner05 from '../components/banner/Banner05';
import BreakingNewsTicker from '../components/banner/BreakingNewsTicker';
import Presale from '../components/presale/index';
import dataPartner from '../assets/fake-data/data-partner';
import dataWork from '../assets/fake-data/data-work';

function HomeOne() {


  useEffect(() => {
    localStorage.setItem("theme", "is_dark");
  }, [])

  return (
    <div className="home-1">
      <Banner01 data={dataPartner} />
      <BreakingNewsTicker />
      <Presale />
      {/* <Banner05 data={dataWork} /> */}
    </div>
  );
}

export default HomeOne;
